import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { isValidRecommendation } from "../../utils/lib-components/RecommendedProducts/utils/is-valid-recommendation.js";
import { RecommendationsGalleryMiniCartSection } from "../../components/RecommendationsGalleryMiniCartSection/lib-components/RecommendedProducts/components/RecommendationsGalleryMiniCartSection/RecommendationsGalleryMiniCartSection.js";
import { RecommendationsGalleryPageSection } from "../../components/RecommendationsGalleryPageSection/lib-components/RecommendedProducts/components/RecommendationsGalleryPageSection/RecommendationsGalleryPageSection.js";
const componentMap = {
  page: RecommendationsGalleryPageSection,
  minicart: RecommendationsGalleryMiniCartSection
};
const RecommendationListContainer = ({
  layout = "minicart",
  isLoading,
  recommendations
}) => {
  const { getLabel } = useIntl();
  if (isLoading || !recommendations.length) {
    return null;
  }
  const Component = componentMap[layout] || RecommendationsGalleryMiniCartSection;
  const validRecommendations = recommendations.filter(isValidRecommendation);
  if (!validRecommendations.length) return null;
  return /* @__PURE__ */ React.createElement(
    Component,
    {
      title: getLabel("products.recommendationList.title"),
      recommendations
    }
  );
};
export {
  RecommendationListContainer
};
//# sourceMappingURL=RecommendationListContainer.js.map
